module.exports = __webpack_public_path__ + "img/copyrightimg.d0289dc0.png";